// src/pages/SmartPages/HomePage.tsx

import React, { useMemo } from 'react';
import UniversalPage from '@/pages/UniversalPage';
import { buildPageConfig } from '@/pages/page-factory';
import { useSiteReviews } from '@/context/reviews';
import { useI18n } from '@/i18n/LanguageProvider'; // ⭐️ NEW
import type { ReviewItem } from '@/constants/core';

const HomePage: React.FC = () => {
  const { reviews } = useSiteReviews();
  const { lang, i18n } = useI18n(); // ⭐️ NEW

  const siteReviews = Array.isArray(reviews)
    ? (reviews as ReviewItem[])
    : undefined;

  const cfg = useMemo(
    () => {
      const configLang = i18n.HTML_LANG as typeof lang;
      return buildPageConfig('home', {
        siteReviews,
        lang: configLang, // ⭐️ IMPORTANT
        i18n,
      });
    },
    [siteReviews, i18n] // ⭐️ IMPORTANT
  );

  return (
    <UniversalPage
      overrides={cfg.overrides}
      internalLinks={cfg.internalLinks}
      eventType="אירוע"
    />
  );
};

export default HomePage;
